import React from 'react';
import { DropDown } from './common';
import { connect } from 'react-redux';
import { DuLieuHeThong } from 'api';

class DropDownChonNoiCapCMND extends React.Component {
  constructor(props, context) {
    super(props);
    this.state = {
      data: this.props.data
    }
  }

  componentDidMount() {
    if(this.props.data.length == 0) {
      DuLieuHeThong.actions.getNoiCap.request().then(res => {
        this.props.dispatch({
          type: 'CAPNHAT_DULIEUHETHONG',
          duLieuHeThong: [{
            key: 'noiCapCMND',
            data: res.data && res.data._embedded && res.data._embedded.coQuanQuanLies ? res.data._embedded.coQuanQuanLies : []
          }]
        })
      })
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.data != this.props.data) {
      this.state.data = nextProps.data;
      this.setState({...this.state})
    }
  }

  onChange(e) {
    this.props.onChange(e);
  }

  render() {
    return (
      <DropDown className={this.props.className} selectedValue={this.props.selectedValue} label="Nơi cấp" options={ this.state.data } keyName='coQuanQuanLyId' valueName='ten' onChange={ this.onChange.bind(this) } placeholder={ this.props.placeholder } name="noiCapCMND" />
    )
  }
}

DropDownChonNoiCapCMND.defaultProps = {
  onChange: function() {
    console.log('Need to assign onChange method');
  },
  placeholder: {
    key: '',
    text: 'Chọn...'
  },
  className: 'col-input',
  data: []
}

let bindStateToProps = state => {
  return {
    data: state.duLieuHeThong.noiCapCMND
  }
}

export default connect(bindStateToProps)(DropDownChonNoiCapCMND);



// WEBPACK FOOTER //
// ./src/components/tt-forms/dropdown-noicapCMND.jsx